<template>
    <el-table style="width:100%" :data="invoice_items" v-if="invoice_items.length">
        <el-table-column prop="type_memo" label="发票类型"></el-table-column>
        <el-table-column prop="title" label="发票抬头"></el-table-column>
        <el-table-column prop="content" label="开票内容"></el-table-column>
        <el-table-column prop="total_amount" label="开票金额"></el-table-column>
        <el-table-column label="开票日期" prop="input_at"></el-table-column>
        <el-table-column prop="taxpayer_id" label="纳税人识别号"></el-table-column>
        <el-table-column prop="bank_name" label="开户行"></el-table-column>
        <el-table-column prop="account" label="账号"></el-table-column>
        <el-table-column center label="操作">
            <template slot-scope="scope">
                <span v-if="scope.row.issue == 1">
                  <span v-if="scope.row.is_delete == 1">
                      已作废
                  </span>
                  <span v-else>已开票</span>
                </span>
                <span v-else>
                  <span :xid="scope.row.id" v-if="scope.row.is_delete != 1">
                      <el-button type="text" size="small" class="express-view"
                                 @click="handleEditInvoice(scope.row.id)">编辑</el-button>
                  </span>
                  <span v-if="scope.row.is_delete != 1">
                      <el-button type="text" size="small" @click="handleDeleteInvoice(scope.row.id)">删除</el-button>
                  </span>
                  <span v-if="scope.row.is_delete == 1">
                      已作废
                  </span>
                </span>

            </template>
        </el-table-column>
    </el-table>
</template>
<script>
    import OrderService from '~/services/order';

    export default {
        data() {
            return {
                invoiceTypes: [],
                types: {
                    1: '普通发票(纸质)',
                    2: '专用发票(纸质)',
                    3: '普通发票(电子)',
                    4: '专用发票(电子)',
                },
            }
        },
        props: {
            invoice: {
                type: Array,
                required: true
            }
        },
        computed: {
            invoice_items: function () {
                return this.invoice.map(item => {
                    let s = this.invoiceTypes.find(type => {
                        return type.value == item.content;
                    });
                    return Object.assign({}, item, {
                        content: s ? s.label : '',
                        type_memo: this.types.hasOwnProperty(item.type) ? this.types[item.type] : ''
                    });
                });
            }
        },
        created() {
          var context = OrderService.myInvoiceContext();
          context.then(res => {
            this.invoiceTypes = res.data;
          });
        },
        methods: {
            handleEditInvoice(id) {
                this.$emit('handleEditInvoice', id);
            },
            handleDeleteInvoice(id) {
                if (this.$route.path == '/order/edit') {
                    this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        console.log('====');
                        OrderService.deleteMyInvoice({ids: [id]}).then((res) => {
                            if (res.code == 0) {
                                this.$emit('handleDeleteInvoice', id);
                            }
                        });
                    })
                } else {
                    this.$emit('handleDeleteInvoice', id);
                }
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/views/order/invoiceShowTable.vue